const colors = {
  primary: "#2563EB",
  light: "#EAF2FF",
  dark: "#0F172A",
  white: "#FFFFFF",
  gray: "#94A3B8",
};

export default colors;